import { format } from 'date-fns';
import { action, computed, observable } from 'mobx';
import { observer } from 'mobx-react';
import { autoinject, bind, Enums, errorRedirect, IDisposable, inject, Loader, Tooltip } from 'Mri.Web.Common';
import * as React from 'react';
import { LinkContainer } from 'react-router-bootstrap';
import { Button } from 'reactstrap';
import { DisplaysStore } from '../Displays/DisplaysStore';
import { CloudConfigsStore } from './CloudConfigsStore';

export interface ICloudConfigStatusItemProps {
    readonly display: string;
    readonly cloudConfigGuid: string;
}

@autoinject
@observer
export class CloudConfigStatusItem extends React.Component<ICloudConfigStatusItemProps> {
    @action
    public async componentDidMount() {
        this.loading = true;
        try {
            await this.displaysStore.loadDisplayConfigStatusAsync(this.props.display);
            this.handle = await this.displaysStore.connectionManager.connect();
            await this.displaysStore.subscribeToDisplayAsync(this.props.display);
        } catch (e: any) {
            errorRedirect(e);
        } finally {
            this.loading = false;
        }
    }

    public async componentWillUnmount() {
        try {
            await this.displaysStore.unsubscribeToDisplayAsync(this.props.display);
            this.handle?.dispose();
        } catch (e: any) {
            console.warn(e);
        }
    }

    public render() {
        const { display } = this.props;
        return (
            <>
                <tr>
                    <td className="align-middle">
                        <LinkContainer to={`/displays/${display}`}>
                            <Button color="link">{display}</Button>
                        </LinkContainer>
                        <Loader loading={this.loading} showSpinner />
                    </td>

                    <td className="align-middle">
                        <span>
                            {this.status?.pollTime ? format(this.status.pollTime, 'EEEE, MMMM do yyyy,  h:mm a') : '-'}
                        </span>
                    </td>

                    <td className="align-middle">
                        <span>{this.updateState}</span>
                        {/*this.status?.exception && <span>{this.getErrorMessage(this.status?.exception)}</span>*/}
                    </td>
                </tr>
            </>
        );
    }

    @bind
    public getErrorMessage(error: any) {
        return typeof error == 'string'
            ? error
            : typeof error == 'object' && typeof error.message == 'string'
                ? error.message
                : typeof error == 'object' && typeof error.Message == 'string'
                    ? error.Message
                    : 'An error has occured. Please try again.';
    }

    @computed
    private get updated() {
        return (
            this.status?.cloudConfigGuid == this.cloudConfig?.cloudConfigGuid &&
            this.status?.cloudConfigVersionGuid == this.cloudConfig?.versionId
        );
    }

    @computed
    private get updating() {
        return (
            this.status?.cloudConfigGuid == this.cloudConfig?.cloudConfigGuid &&
            this.status?.cloudConfigVersionGuid != this.cloudConfig?.versionId
        );
    }

    @computed
    private get updateState() {
        if (this.updated) return 'Up To Date';
        else if (this.updating) return 'Updating...';
        else return 'Idle';
    }

    @computed
    private get status() {
        return this.displaysStore.configStatuses.get(this.props.display);
    }

    @computed
    private get cloudConfig() {
        return this.cloudConfigsStore.configs.get(this.props.cloudConfigGuid);
    }

    @observable
    private loading = false;
    private handle?: IDisposable;
    @inject
    private readonly displaysStore!: DisplaysStore;
    @inject
    private readonly cloudConfigsStore!: CloudConfigsStore;
}
